<template>
  <div>
    <br />
    <h1 class="text-xs-center">Advanced Settings</h1>
    <v-layout row wrap justify-center>
      <v-flex xs12 sm10 md8 lg6 pa-2>
        <v-list two-line>
          <v-list-tile :to="{ name: 'advanced-hours-of-operation-templates' }" ripple>
            <v-list-tile-action>
              <v-icon>fal fa-business-time</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Hours Of Operation Templates</v-list-tile-title>
              <v-list-tile-sub-title>Manage reusable operational-hours templates</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider />
          <v-list-tile :to="{ name: 'advanced-offline-monitors' }" ripple>
            <v-list-tile-action>
              <v-icon>fal fa-satellite-dish</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Offline Monitors</v-list-tile-title>
              <v-list-tile-sub-title>Configure offline bus and EV charger notifications</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider />
          <v-list-tile :to="{ name: 'advanced-other-settings' }" ripple>
            <v-list-tile-action>
              <v-icon>fal fa-sliders-h</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Other Settings</v-list-tile-title>
              <v-list-tile-sub-title>Payout fees and beacon registration restrictions</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <template v-if="isSuperAdmin">
            <v-divider />
            <v-list-tile :to="{ name: 'advanced-reports' }" ripple>
              <v-list-tile-action>
                <v-icon>fal fa-chart-line</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Reports</v-list-tile-title>
                <v-list-tile-sub-title>Monitor report workers and request reports on demand</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
          <v-divider />
          <v-list-tile :to="{ name: 'advanced-realtime-diagnostics' }" ripple>
            <v-list-tile-action>
              <v-icon>fal fa-stethoscope</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Realtime Diagnostics</v-list-tile-title>
              <v-list-tile-sub-title>Glance-first health checks for boarding, pricing, workers, and jobs</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider />
          <v-list-tile :to="{ name: 'advanced-message-queue' }" ripple>
            <v-list-tile-action>
              <v-icon>fal fa-sms</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Message Queue</v-list-tile-title>
              <v-list-tile-sub-title>Monitor SMS, email, and push queue status without message content</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider />
          <v-list-tile :to="{ name: 'advanced-vehicle-kwh-usage' }" ripple>
            <v-list-tile-action>
              <v-icon>fal fa-bolt</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Vehicle KWh Usage</v-list-tile-title>
              <v-list-tile-sub-title>Enter daily vehicle charging usage</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider />
          <v-list-tile :to="{ name: 'advanced-ev-chargers' }" ripple>
            <v-list-tile-action>
              <v-icon>fal fa-charging-station</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>EV Chargers</v-list-tile-title>
              <v-list-tile-sub-title>Manage charger provisioning, location, and credentials</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <template v-if="showSimulators">
            <v-divider />
            <v-list-tile :to="{ name: 'advanced-simulators' }" ripple>
              <v-list-tile-action>
                <v-icon>fal fa-flask</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Simulators</v-list-tile-title>
                <v-list-tile-sub-title>Test partner apps against quickpay</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </v-list>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import src from './src'
export default src
</script>
